exports.formats = {
    percentage: (value) =>
        Intl.NumberFormat('de-CH', {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value),
    percentageShort: (value) =>
        Intl.NumberFormat('de-CH', {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value),
    amount: (value) =>
        Intl.NumberFormat('de-CH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value),
    amountShort: (value) =>
        Intl.NumberFormat('de-CH', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value),
    amountCompactShort: (value) =>
        Intl.NumberFormat('de-CH', {
            minimumSignificantDigits: 3,
            maximumSignificantDigits: 3,
            notation: 'compact',
            compactDisplay: 'short',
        }).format(value),
    price: (value) =>
        Intl.NumberFormat('de-CH', {
            style: 'currency',
            currency: 'CHF',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
            .format(value)
            .replace('CHF-', 'CHF -'),
    priceShort: (value) =>
        Intl.NumberFormat('de-CH', {
            style: 'currency',
            currency: 'CHF',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
            .format(value)
            .replace('CHF-', 'CHF -'),
    priceCompact: (value) =>
        Intl.NumberFormat('de-CH', {
            style: 'currency',
            currency: 'CHF',
            notation: 'compact',
            compactDisplay: 'short',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
            .format(value)
            .replace('CHF-', 'CHF -'),
    priceCompactShort: (value) =>
        Intl.NumberFormat('de-CH', {
            style: 'currency',
            currency: 'CHF',
            notation: 'compact',
            compactDisplay: 'short',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
            .format(value)
            .replace('CHF-', 'CHF -'),
    dateFormal: (value) =>
        Intl.DateTimeFormat('de-CH', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
        })
            .format(new Date(value))
            .replace(',', ''),
    bidTimestamp: (value) =>
        Intl.DateTimeFormat('de-CH', {
            year: undefined,
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
        })
            .format(new Date(value))
            .replace(',', ''),
    unit: (value, _language, options) =>
        Intl.NumberFormat('de-CH', {
            style: 'unit',
            unit: 'year',
            unitDisplay: 'long',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
            ...options,
        }).format(value),
};
